import isEmpty from "../validation/is-empty";

import {
  SET_CURRENT_USER,
  HAS_SEEN_RELEASE,
  CLEAR_HAS_SEEN_RELEASE
} from "../actions/types";

const initialState = {
  isAuthenticated: false,
  user: {},
  hasSeenRelease: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        user: action.payload
      };
    case HAS_SEEN_RELEASE:
      return {
        ...state,
        hasSeenRelease: action.payload
      };
    case CLEAR_HAS_SEEN_RELEASE:
      return {
        ...state,
        hasSeenRelease: null
      };
    default:
      return state;
  }
}
